import { emit } from '../postMessage';

export function ExpiredScreen() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-xl font-semibold">Session expired</h1>
      <p className="text-sm opacity-70">Please return to your casino and start a new session.</p>
      <button
        className="rounded bg-gp-button px-4 py-2 text-gp-bg"
        onClick={() => emit('session_expired')}
        type="button"
      >
        Return
      </button>
    </div>
  );
}
